import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const UserDashboard = () => {
  const [userInfo, setUserInfo] = useState({});
  const [purchasedSubjects, setPurchasedSubjects] = useState([]);
  const [recommendedSubjects, setRecommendedSubjects] = useState([]);
  const [progressSummary, setProgressSummary] = useState([]);

useEffect(() => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?._id;

  if (!userId) return;

  // Fetch purchased subjects
  axios.get(`https://backend.scholarkart.in/api/user/mysubjects?userId=${userId}`)
    .then((res) => setPurchasedSubjects(res.data))
    .catch((err) => console.error("Failed to fetch purchased subjects:", err));

  // Fetch recommended subjects
    axios.get('https://backend.scholarkart.in/api/subjects/on-sale')
      .then(response => {
        setRecommendedSubjects(response.data);
      })
      .catch(error => {
        console.error('Error fetching subjects:', error);
      });

  // ✅ Fetch progress summary
axios.get(`https://backend.scholarkart.in/api/progress/summary?userId=${userId}`)
  .then(res => {
    console.log("Progress Summary Data:", res.data);  // 👈 Add this
    setProgressSummary(res.data);
  })
  .catch(err => console.error("Failed to fetch progress summary:", err));

}, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f5f7fa] to-[#f5f7fa] dark:bg-gray-900 py-10 px-4">
      {/* Top Cards */}

      {progressSummary.length > 0 && (
        <div className="mb-12">
          <h2 className="text-2xl font-bold mb-4 text-[#012f6e] dark:text-white">📈 Progress Summary</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {progressSummary.map((item) => (
              <div key={item.subjectId} className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md">
                <h3 className="text-lg font-semibold text-[#012f6e] dark:text-white mb-2">{item.subjectName}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                  {item.completed}/{item.total} chapters completed
                </p>
                <div className="w-full bg-gray-300 rounded-full h-2">
                  <div
                    className="bg-green-500 h-2 rounded-full"
                    style={{ width: `${item.percent}%` }}
                  ></div>
                </div>
                <p className="text-xs text-right text-gray-500 dark:text-gray-400 mt-1">{item.percent}% complete</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Enrolled Subjects */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-4 text-[#012f6e] dark:text-white">Your Purchased Subjects</h2>
        {purchasedSubjects.length === 0 ? (
          <p className="text-gray-600 dark:text-gray-300">You haven't purchased any subjects yet.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {purchasedSubjects.map((subject) => (
              <div key={subject._id} className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md">
                <img
                  src={subject.coverImage}
                  alt={subject.subjectName}
                  className="w-full h-32 object-cover rounded mb-4"
                />
                <h3 className="text-xl font-bold text-[#012f6e] dark:text-white mb-2">
                  {subject.subjectName}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                  {subject.subjectOutcome?.slice(0, 100)}...
                </p>
                <Link
                  to={`/elearning/${subject._id}`}
                  className="inline-block w-full bg-green-600 text-white text-center py-2 rounded-full hover:bg-green-700 transition"
                >
                  Access Course
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Recommended Subjects */}
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#012f6e] dark:text-white">Subjects on Sale</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {recommendedSubjects.map((subject) => (
            <div key={subject._id} className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md">
              <img
                src={subject.coverImage}
                alt={subject.subjectName}
                className="w-full h-32 object-cover rounded mb-4"
              />
              <h3 className="text-xl font-bold text-[#012f6e] dark:text-white mb-2">
                {subject.subjectName}
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                {subject.subjectOutcome?.slice(0, 100)}...
              </p>
              <Link
                to={`/subjects_details/${subject._id}`}
                className="inline-block w-full bg-orange-500 text-white text-center py-2 rounded-full hover:bg-orange-600 transition"
              >
                Explore Module
              </Link>
            </div>
          ))}
        </div>
      </div>

      
    </div>
  );
};

export default UserDashboard;
